import { parseResponse } from "../../utils/common_lib";
import { baseApi } from "../baseApi";
export const visitSummariesApi = baseApi.injectEndpoints({
  tagTypes: ["VisitSummaries"],
  endpoints: (builder) => ({
    getVisitSummaries: builder.query({
      query: (params) => {
        return {
          url: `/encounters.json`,
          method: "GET",
          params: params,
        };
      },
      transformResponse: (response, meta, arg) => {
        return parseResponse(response);
      },
    }),
    printSummary: builder.query({
      query: (params) => {
        return {
          url: `/notes/print_summary.json`,
          method: "GET",
          params: params,
        };
      },
      transformResponse: (response, meta, arg) => {
        return parseResponse(response);
      },
    }),
  }),
});

// Export hooks for usage in functional components
export const { useGetVisitSummariesQuery, GetPrintSummaryQuery } =
  visitSummariesApi;
